import { store } from '../../store';

const hideEmailFunctionality = process.env.REACT_APP_HIDE_EMAIL_INSIGHTS_FUNCTIONALITY === 'true';

export const getUserToken = () => {
  const state = store.getState();
  return (
    state?.user?.token || {
      access: '',
      refresh: '',
    }
  );
};

export const getUserAuth = () => {
  const state = store.getState();
  return state?.user?.isAuth || false;
};

export const getUserInfo = () => {
  const state = store.getState();
  return state?.user?.userInfo || {};
};

export const getSelectedTemplateId = () => {
  const state = store.getState();
  return state?.user?.selectedTemplateId || 0;
};

export const getSelectedEmailTemplateId = () => {
  const state = store.getState();
  return state?.user?.selectedEmailTemplateId || 0;
};

export const getSelectedTimeRange = () => {
  const state = store.getState();
  return state?.user?.selectedTimeRange || null;
};

export const getOrgId = () => {
  const state = store.getState();
  return state?.user?.orgId || null;
};

export const getSelectedBackground = () => {
  const state = store.getState();
  return state?.user?.selectedBackground || '#181818';
};

export const getSelectedHover = () => {
  const state = store.getState();
  return (
    state?.user?.selectedHover || {
      selectedBg: '#E8F4FE',
      selectedColor: '#1677FF',
    }
  );
};
export const getSelectedBrandLogo = () => {
  const state = store.getState();
  return state?.user?.selectedBrandLogo || '';
};

export const getSelectedInsight = () => {
  const state = store.getState();
  if (hideEmailFunctionality) {
    return 'Calls';
  }
  return state?.user?.selectedInsight || 'Calls';
};
